<template>  
  <div class="buySuc"> 
      <span class="buySuc-span"></span>
      <div class="buySuc-div"> 
        <h1>购买成功</h1>
        <h2>订单号：MD053829</h2>
        <p>感谢您购买我们的课程，我们致力于为您提供优质的在线学习体验。</p>
        <div>
          <button>开始学习</button>
          <button>浏览其他课程</button>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'buySuc',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .buySuc{
      background-image: url(https://static.wixstatic.com/media/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.jpg/v1/fill/w_1920,h_823,al_c,q_85,usm_0.66_1.00_0.01/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.webp);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 0 0;
      position: relative;
      width: 100%;
			padding-top:160px;
			padding-bottom: 160px;
  }
  .buySuc .buySuc-span{
    /*  position: absolute;
      top:0;
      right: 0;
      background-color:rgba(0,0,0,0.5);
      height: 100%;
      width: 100%; */
  }
  .buySuc .buySuc-div{
      width: 529px;
      height: 500px;
			margin:0 auto;
      background-color: rgba(0, 0, 0, 0.5);
      z-index:1;
      color:#fff;
      text-align: center;
      padding-top: 60px;
			border-radius: 20px;
  }
 .buySuc .buySuc-div h1{
   font-size: 50px;
   font-family:museo-slab-w01-100,serif;
   
 }
 .buySuc .buySuc-div h2{
   font-family:lato-light,lato,sans-serif;
   font-weight: 500;
   font-size: 15px;
   margin-bottom: 100px;
 }
 .buySuc .buySuc-div p{
   width: 275px;
   font-size: 17px;
   margin:0 auto;
   text-align: center;
   margin-bottom: 150px;
 }
 .buySuc .buySuc-div button{
    padding: 0 15px;
    height: 30px;
    background-color: unset;
    border: solid rgba(250, 250, 250, 1) 1px;
    border-radius: 20px;
    color:#FAFAFA;
    line-height: 29px;
    margin-right: 60px;
    margin-left: 60px;
 }
  .buySuc .buySuc-div button:hover{
    transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
    background-color: #fafafa;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/buySucess.vue